import $ from "jquery";
import PropertyListView from "./property-list-view";
import PropertyDetailView from "./property-detail-view";
import PropertyListWidget from "./property-list-widget";
import PropertyListMapWidget from "./property-list-map-widget";
import PropertyModalWidget from "./property-modal-widget";

(($) => {
  if (typeof $ === "undefined") {
    throw new TypeError(
      "Listings JavaScript requires jQuery. jQuery must be included before Forms JavaScript."
    );
  }
})($);

export {
  PropertyListView,
  PropertyDetailView,
  PropertyListWidget,
  PropertyListMapWidget,
  PropertyModalWidget,
};
